import React from 'react'

import clsx from 'clsx'

import Accordion from 'components/Accordion'
import { Container } from 'components/Grid'
import Paper from 'components/Paper'

import KeyFeaturesHeading from '../KeyFeaturesHeading'
import FeatureWithRating from './components/FeatureWithRating'

import classes from './KeyFeatures.module.scss'

/** @type {import("./types").default} */
const KeyFeatures = ({ className, listing, isFirstCard, ...props }) => {
  const { key_features } = listing
  const enabledFeatures = listing?.key_features?.filter(feature => feature.global_feature_id).length
  const countFeatures = key_features?.length
  const countOfFeatures = `${enabledFeatures}/${countFeatures}`
  return (
    <Paper className={clsx(classes.root, className)} square elevation={0} {...props}>
      <Accordion
        defaultExpanded={isFirstCard}
        summary={<KeyFeaturesHeading label={countOfFeatures} listing={listing} />}
        className={clsx(classes.root, className)}
      >
        <Container className={classes.keyFeaturesContainer}>
          {key_features.map((feature, index) => (
            <FeatureWithRating key={index} feature={feature} />
          ))}
        </Container>
      </Accordion>
    </Paper>
  )
}

export default KeyFeatures
